import firebase from "firebase";

const firebaseApp = firebase.initializeApp({

        apiKey: "AIzaSyAQC4XPdM664mQWwqEqQ_QiQOoKPMhCdTY",
        authDomain: "facebook-messenger-clone-9a839.firebaseapp.com",
        databaseURL: "https://facebook-messenger-clone-9a839.firebaseio.com",
        projectId: "facebook-messenger-clone-9a839",
        storageBucket: "facebook-messenger-clone-9a839.appspot.com",
        messagingSenderId: "167294017746",
        appId: "1:167294017746:web:5502145c8b7a51c387cd0b",
        measurementId: "G-HMB7QYH89X"

});

const db = firebaseApp.firestore();

export default db;